/**
 * Yeni JSON endpoint'lerinin BaseResult / BaseDataResult zarfını normalize eder.
 * HTTP 200 içinde isSuccess=false gelebileceğinden başarı kararını status'a
 * veya message değerine göre değil, yalnızca isSuccess alanına göre verir.
 *
 * @param {object|null|undefined} response
 * @returns {{ isSuccess: boolean, message: number|string|null, exceptionMessage: string|null, data: any }}
 */
export const normalizeBaseResult = (response) => {
  const result = response && typeof response === "object" ? response : {};

  return {
    ...result,
    isSuccess: result.isSuccess === true,
    message: result.message ?? null,
    exceptionMessage: result.exceptionMessage ?? null,
    data: result.data ?? null,
  };
};

export default normalizeBaseResult;
